import React from 'react';
import Dashboard from '../Dashboard';
import UploadOtherInfoMain from './UploadOtherInfoMain';

export default function UploadOtherInfo() {
    return (
        <div>
            <Dashboard cmp={<UploadOtherInfoMain />} />
        </div>
    )
}

